import axios from './axios';

export default class marketing  {

    constructor() {
        this.axios = new axios();
    }

    getFlinksToken = async () => {
        return await this.axios.get("generate-flinks-token");
    }

    saveFlinksApplicant = async (applicantId) => {
        let request = {
            ApplicantId: applicantId
        }

        return await this.axios.post("save-flinks-applicant", request);
    }

    harvestAccountDetails = async (applicantId, loginId, institution) => {
        let request = {
            ApplicantId: applicantId,
            LoginId: loginId,
            Institution: institution
        }
        return await this.axios.post("harvest-account-details", request);
    }

    retryHarvest = async (applicantId, requestId) => {
        let request = {
            ApplicantId: applicantId,
            RequestId: requestId
        }

        return await this.axios.post("retry-harvest", request);
    }
}